/**
 * Utilidades de fechas — manejo de zona horaria.
 *
 * Problema: el backend serializa los campos DATE puros (Prisma @db.Date, ej.
 * fechaNacimiento, fecha de eventos/asignaciones) como 'YYYY-MM-DDT00:00:00.000Z'
 * (medianoche UTC). Al hacer new Date(iso) en el navegador, las zonas UTC-
 * reciben el día anterior (ej. Colombia UTC-5: el 10/09 00:00 UTC = 09/09 19:00
 * local), por lo que la fecha se muestra desplazada un día.
 *
 * Regla de uso:
 * - Campos DATE puros  → parseFechaLocal / formatFechaLocal (ignoran la hora).
 * - Timestamps reales  → seguir usando new Date() normalmente
 *   (creadoEn, actualizadoEn, ultimoAcceso, mensajes, etc.).
 */

/** Parsea solo la parte 'YYYY-MM-DD' como fecha en hora local (sin conversión UTC). */
export const parseFechaLocal = (value: string | Date): Date => {
  const str = typeof value === 'string' ? value : value.toISOString();
  const [anio, mes, dia] = str.slice(0, 10).split('-').map(Number);
  return new Date(anio, mes - 1, dia);
};

/** Formatea un campo DATE puro en la zona horaria local del navegador. */
export const formatFechaLocal = (
  value: string | Date | null | undefined,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' },
  locale = 'es-CO',
): string => {
  if (!value) return 'No especificado';
  return parseFechaLocal(value).toLocaleDateString(locale, options);
};
